import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ko from './locales/ko.json'
import en from './locales/en.json'

const supportedLngs = ['ko', 'en']
const params = new URLSearchParams(window.location.search)
const queryLng = params.get('lng')
const initialLng = supportedLngs.includes(queryLng) ? queryLng : 'ko'

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en }
  },
  lng: initialLng,
  fallbackLng: 'ko',
  supportedLngs,
  interpolation: {
    escapeValue: false
  }
})

export default i18n
